import React, {useEffect, useState,useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';
import SidebarOption from './SidebarOption';
const Sidebar = () => {
    const [isMinimized, setIsMinimized] = useState(false);
    const [activeOption, setActiveOption] = useState(null);
    const [activeSubOption, setActiveSubOption] = useState(null);
    // const { setIsNewPopupOpen } = useContext(AddPopupContext);
    const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // Add this line


    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname;
        const searchParams = new URLSearchParams(location.search);
        
        if (currentPath === '/dashboard') {
            setActiveOption('Dashboard');
        } else if (currentPath === '/states' || searchParams.get('country')) {
            setActiveOption('Localization');
            setActiveSubOption('States');
        } else if (currentPath === '/countries') {
            setActiveOption('Localization');
            setActiveSubOption('Countries');
        } else if (currentPath.startsWith('/user-accounts')) {
            setActiveOption('Subscription');
            setActiveSubOption('User Accounts');
        } else if (currentPath.startsWith('/subscriptions')) {
            setActiveOption('Subscription');
            setActiveSubOption('Subscriptions');        
        } else if (currentPath.startsWith('/internal-users')) {
            setActiveOption('Settings');
            setActiveSubOption('Internal Users');
        } else if (currentPath.startsWith('/internal-user-roles')) {
            setActiveOption('Settings');
            setActiveSubOption('Internal User roles');
        } else if (currentPath.startsWith('/basic-exchange-history')) {
            setActiveOption('Localization');
            setActiveSubOption('Currencies');
        } else if (currentPath.startsWith('/payments')) {
            setActiveOption('Subscription');
            setActiveSubOption('Payments');
        } else if (currentPath.startsWith('/our-plans')) {
            setActiveOption('Plans');
            setActiveSubOption('Our Plans');
        } else if (currentPath.startsWith('/faqs')) {
            setActiveOption('FAQ\'s');
            setActiveSubOption('FAQ\'s'); 
        } else if (currentPath.startsWith('/notification-list')) {
            setActiveOption('Notifications');
            setActiveSubOption('Notification List');  
        } else if (currentPath.startsWith('/notification-category')) {
            setActiveOption('Notifications');
            setActiveSubOption('Category');   
        } else if (currentPath.startsWith('/internal-users')) {
            setActiveOption('Settings');
            setActiveSubOption('Internal Users');                                                
        } else if (currentPath.startsWith('/customers')) {
            setActiveOption('Subscription');
            setActiveSubOption('Customers');            
        } else {
        }
    }, [location.pathname, location.search]);
      const handleMainOptionClick = (optionName, path, subOptions) => {
        setActiveOption(optionName);
        setActiveSubOption(subOptions && subOptions.length > 0 ? subOptions[0] : null);
        navigate(path);
      };
    const handleSubOptionClick = (subOption) => {
        setActiveSubOption(subOption);
        switch (subOption) {
            case 'Subscriptions':
                navigate('/subscriptions');
                break;
            case 'Customers':
                navigate('/customers');
                break;
            case 'User Accounts':
                navigate('/user-accounts');
                break;
            case 'Access Logs':
                navigate('/access-logs');
                break;
            case 'User Roles':
                navigate('/user-roles');
                break;
            case 'Payments':
                navigate('/payments');
                break;
            case 'Our Plans':
                navigate('/our-plans');
                break;
            case 'Features':
                navigate('/features');
                break;
            case 'Countries':
                navigate('/Countries');
                break;
            case 'States':
                navigate('/States');
                break;
            case 'Currencies':
                navigate('/Currencies');
                break;
            case 'Taxes':
                navigate('/Taxes');
                break;
            case 'FAQ\'s':
                navigate('/faqs');
                break;
            case 'FAQ Categories':
                navigate('/faq-categories');
                break;
            case 'Notification List':
                navigate('/notification-list');
                break;
            case 'Recipient Groups':
                navigate('/recipient-groups');
                break;
            case 'Category':
                navigate('/notification-category');
                break;
            case 'Internal Users':
                navigate('/internal-users');
                break;
            case 'Internal User roles':
                navigate('/internal-user-roles');
                break;
            case 'Email Configuration':
                navigate('/email-configuration');
                break;     
            case 'User Permissions':
                navigate('user-permissions')
            default:
                break;
        }
    };

    const toggleSidebar = () => {
        setIsMinimized(!isMinimized);
    };
    const togglePopup = () => {
        setIsNewPopupOpen(!isNewPopupOpen);
      };
    return (
        <div className={`sidebar ${isMinimized ? 'minimized' : ''}`}>
            <SidebarOption
                imageSrc="dashboard"
                optionName="Dashboard"
                isActive={activeOption === 'Dashboard'}
                onMainOptionClick={() => handleMainOptionClick('Dashboard', '/dashboard')}
                showPlusIconForMainOption={false}
                isMinimized={isMinimized}
                isNewPopupOpen={isNewPopupOpen} 
                setIsNewPopupOpen={setIsNewPopupOpen} 
            />

            <SidebarOption
                imageSrc="subscription"
                optionName="Subscriptions"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'Subscription'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('Subscription', '/subscriptions', ['Subscriptions', 'Customers', 'User Accounts', 'Access Logs', 'User Roles', 'Payments'])}
                subOptions={isMinimized ? [] : ['Subscriptions', 'Customers', 'User Accounts', 'Access Logs', 'User Roles', 'Payments']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            />       

            <SidebarOption
                imageSrc="plans"
                optionName="Plans"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'Plans'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('Plans', '/our-plans', ['Our Plans', 'Features'])}
                subOptions={isMinimized ? [] : ['Our Plans', 'Features']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            />   

            <SidebarOption
                imageSrc="localization"
                optionName="Localization"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'Localization'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('Localization', '/countries', ['Countries', 'States', 'Currencies', 'Taxes'])}
                subOptions={isMinimized ? [] : ['Countries', 'States', 'Currencies', 'Taxes']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            />

            <SidebarOption
                imageSrc="faq"
                optionName="FAQ's"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'FAQ\'s'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('FAQ\'s', '/faqs', ['FAQ\'s', 'FAQ Categories'])}
                subOptions={isMinimized ? [] : ['FAQ\'s', 'FAQ Categories']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            /> 

            <SidebarOption
                imageSrc="language"
                optionName="Languages"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForMainOption={true}
                isActive={activeOption === 'Languages'}
                onMainOptionClick={() => handleMainOptionClick('Languages', '/languages')}
                isMinimized={isMinimized}
                setIsNewPopupOpen={setIsNewPopupOpen}
            />

            <SidebarOption
                imageSrc="trans"
                optionName="Translations"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForMainOption={true}
                isActive={activeOption === 'Translations'}
                onMainOptionClick={() => handleMainOptionClick('Translations', '/translations')}
                isMinimized={isMinimized}
                setIsNewPopupOpen={setIsNewPopupOpen} // Pass function
                
            />
            <SidebarOption
                imageSrc="notifications"
                optionName="Notifications"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'Notifications'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('Notifications', '/notification-list', ['Notification List', 'Recipient Groups','Category'])}
                subOptions={isMinimized ? [] : ['Notification List', 'Recipient Groups','Category']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            /> 
            <SidebarOption
                imageSrc="settings"
                optionName="Settings"
                expandImg="expand"
                plusImg="plus"
                showPlusIconForSubpoints={true}
                isMinimized={isMinimized}
                isActive={activeOption === 'Settings'}
                activeSubOption={activeSubOption}
                onMainOptionClick={() => handleMainOptionClick('Settings', '/Internal-users', ['Internal Users', 'Internal User roles','Email Configuration','User Permissions'])}
                subOptions={isMinimized ? [] : ['Internal Users', 'Internal User roles','Email Configuration','User Permissions']}
                onSubOptionClick={handleSubOptionClick}
                setIsNewPopupOpen={setIsNewPopupOpen}
            /> 

            <div className='minimize' onClick={toggleSidebar}>
                <svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M3.05388 11.5L12 21.0836L10.211 23L0.370429 12.4582C0.133243 12.2041 0 11.8594 0 11.5C0 11.1406 0.133243 10.7959 0.370429 10.5418L10.211 0L12 1.91644L3.05388 11.5Z" fill="#424242"/>
                </svg>
            </div>
        </div>
    );
};

export default Sidebar;

